import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const baseUrl = 'https://mobile.pwtech.ro';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [generalError, setGeneralError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = async () => {
    setUsernameError('');
    setPasswordError('');
    setGeneralError('');

    let hasError = false;

    if (!username) {
      setUsernameError('Enter username');
      hasError = true;
    }

    if (!password) {
      setPasswordError('Enter password');
      hasError = true;
    }

    if (hasError) return;

    setLoading(true);

    try {
      const res = await fetch(`${baseUrl}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem('codeLink', data.token);
        localStorage.setItem('userId', data.userId);
        navigate('/');
      } else {
        // Handle specific errors based on the response
        if (data.error === 'Incorrect username') {
          setUsernameError('Incorrect username');
        } else if (data.error === 'Incorrect password') {
          setPasswordError('Incorrect password');
        } else {
          setGeneralError(data.error || 'Login failed');
        }
      }
    } catch (err) {
      setGeneralError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h2>Login</h2>

      <input
        placeholder="Username"
        value={username}
        onChange={(e) => {
          setUsernameError("")
          setUsername(e.target.value)}}
        style={{
          borderColor: usernameError ? 'red' : '',
        }}
      /><br />
      {usernameError && (
        <p style={{ color: 'red', fontSize: '12px', marginTop: '-5px' }}>
          {usernameError}
        </p>
      )}

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => {
          setPasswordError("")
          setPassword(e.target.value)}}
        style={{
          borderColor: passwordError ? 'red' : '',
        }}
      /><br />
      {passwordError && (
        <p style={{ color: 'red', fontSize: '12px', marginTop: '-5px' }}>
          {passwordError}
        </p>
      )}

      <button onClick={login} disabled={loading}>
        {loading ? 'Logging in...' : 'Login'}
      </button>

      {generalError && <p style={{ color: 'red', marginTop: 10 }}>{generalError}</p>}
    </div>
  );
}

export default LoginPage;
